module.exports = __webpack_public_path__ + "img/panama.c8526ff0.svg";